/** Pending vs Unloaded lists on the ITCL Unload tab. Default is pending. */

export const UNLOAD_STATUS_TABS = [
  { id: 'pending', label: 'Pending' },
  { id: 'unloaded', label: 'Unloaded' },
];

export const matchesUnloadStatus = (row, status) => (
  status === 'unloaded' ? Boolean(row?.unloaded) : !row?.unloaded
);
